import React from 'react'
// import '../css/coverstory.css'
import { Link } from 'react-router-dom'
import Navbar from '../Navbar'

export default function CoverStory() {
  return (

    <>
   <Navbar/>

   <div className="insights-section">
        <div className="insights-wrapper">
          <div className="profile-wrapper">
            <img
              src="./images/trump.png"
              alt="Person 1"
              className="profile-image"
            />
            <div className="profile-content">
              <div className="profile-title">
                <h1> Driving Innovation and Fostering Collaboration in the Global
                Logistics Industry</h1>
               
              </div>
              <div className="profile-subtitle">
                <p>Sonia Ferreira, Global Key Client Director, A.P. Moller - Maersk</p>
                
              </div>
              
              <div className="profile-description">
                <p>Sonia Ferreira started her business journey with a strong
                background in Economics. Her early career led her to Chambers of
                Commerce in two very different…</p>
                
              </div>
              <div className="profile-details">
                <div>
                  <i>📅</i>June 25, 2024
                </div>
                <div>
                  <i>💬</i>0
                </div>
              </div>
            </div>
          </div>

          <div className="profile-wrapper">
            <img
              src="./images/trump.png"
              alt="Person 2"
              className="profile-image"
            />
            <div className="profile-content">
              <div className="profile-title">
                <h1>Sharing Stories. Changing Lives.</h1>
                
              </div>
              <div className="profile-subtitle">
                <p>Candace Carnahan, Safety Innovator and Motivational Speaker</p>
                
              </div>
             
              <div className="profile-description">
                <p>Candace Carnahan believes in a simple truth: safety isn’t just a
                task; it’s a mindset, a way of living. Whether she’s clad in
                steel-toed boots…</p>
                
              </div>
              <div className="profile-details">
                <div>
                  <i>📅</i>May 24, 2024
                </div>
                <div>
                  <i>💬</i>0
                </div>
              </div>
            </div>
          </div>

          <div className="profile-wrapper">
            <img
              src="./images/trump.png"
              alt="Person 3"
              className="profile-image"
            />
            <div className="profile-content">
              <div className="profile-title">
                <h1> Sharing Stories. Changing Lives.</h1>
               
              </div>
              <div className="profile-subtitle">
                <p>Candace Carnahan, Safety Innovator and Motivational Speaker</p>
                
              </div>
              
              <div className="profile-description">
                <p>Candace Carnahan believes in a simple truth: safety isn’t just a
                task; it’s a mindset, a way of living. Whether she’s clad in
                steel-toed boots…</p>
                
              </div>
              <div className="profile-details">
                <div>
                  <i>📅</i>May 24, 2024
                </div>
                <div>
                  <i>💬</i>0
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="advertisement-section"></div>
      </div>
</>
  )
}
